import { useQueryClient } from "@tanstack/react-query";
import { produce } from "immer";

import { useSelectedWorkspaceContext } from "common/helpers/SelectedWorkspaceContext";

import getQueryKeys from "./getQueryKeys";

import type { DetailedLead } from "../types";

//this function is used to update detailed leads
export default function useUpdateDetailedLead() {
  const queryClient = useQueryClient();

  const { id: workspaceId } = useSelectedWorkspaceContext();
  const { leadsKeys } = getQueryKeys(workspaceId);

  async function updateDetailedLead(
    leadId: string,
    updateFunction: (lead: DetailedLead) => void,
  ) {
    if (queryClient.getQueryData(leadsKeys.details(leadId))) {
      await queryClient.cancelQueries({
        queryKey: leadsKeys.details(leadId),
      });
      queryClient.setQueryData<DetailedLead>(
        leadsKeys.details(leadId),
        (prevLead) =>
          produce(prevLead, (draftState) => {
            updateFunction(draftState);
          }),
      );
    }
  }
  async function updateAllDetailedLeads(
    updateFunction: (lead: DetailedLead) => void,
  ) {
    if (queryClient.getQueriesData({ queryKey: leadsKeys.details() })) {
      await queryClient.cancelQueries({
        queryKey: leadsKeys.details(),
      });
      queryClient.setQueriesData<DetailedLead>(
        { queryKey: leadsKeys.details() },
        (lead) => {
          if (lead) {
            return produce(lead, updateFunction);
          }
        },
      );
    }
  }
  return { updateDetailedLead, updateAllDetailedLeads };
}
